import React from "react";

const Table = ({
  className,
  id,
  children,
  ...props
}) => {
    return (
        <table
            id={id}
            className={className}
            {...props}
        >
        {children}
        </table>
    );
};

export default Table;